import { Model } from 'vue-models'
import TextField from './types/TextField'
import DateTime from './types/DateTime'

export default class Event extends Model {
  static defaults () {
    return {
      name: 'event',
      basePath: 'events'
    }
  }
  static schema () {
    return {
      id: { type: Number },
      code: { type: Number },
      code_description: { type: TextField },
      walltime: { type: DateTime },
      details: { type: Object }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/event.js